import { render, staticRenderFns } from "./RecipeInstruction.vue?vue&type=template&id=06afda20&scoped=true&"
import script from "./RecipeInstruction.vue?vue&type=script&lang=js&"
export * from "./RecipeInstruction.vue?vue&type=script&lang=js&"
import style0 from "./RecipeInstruction.vue?vue&type=style&index=0&id=06afda20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06afda20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06afda20')) {
      api.createRecord('06afda20', component.options)
    } else {
      api.reload('06afda20', component.options)
    }
    module.hot.accept("./RecipeInstruction.vue?vue&type=template&id=06afda20&scoped=true&", function () {
      api.rerender('06afda20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecipeInstruction.vue"
export default component.exports